var responseClone: any;

export const loadJson = (url: string) =>
  fetch(url)
    .then((res) => {
      responseClone = res.clone();
      return res.json();
    })
    .then(
      (data) => {
        return data;
      },
      () => {
        responseClone.text().then((bodyText: any) => {
          console.log(bodyText);
        });
      },
    );

export const loadScript = (url: string, callback?: any) => {
  const script = document.createElement('script');
  script.src = url;
  script.async = true;
  const firstScriptTag = document.getElementsByTagName('script')[0];
  firstScriptTag?.parentNode?.insertBefore(script, firstScriptTag);
  script.onload = callback;
};
